var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"page"}},[_c('div',{staticClass:"page-module",on:{"click":_vm.closeModule}},[_c('div',{staticClass:"radio-popup",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"popup-head",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('radio-item',_vm._b({},'radio-item',{
          options: _vm.optionsClone,
          edit: _vm.edit,
          valKey: _vm.valKey,
          remove: _vm.remove,
          editSwitch: _vm.editSwitch,
          delSwitch: _vm.delSwitch,
          addItemSwitch: _vm.addItemSwitch,
          addItemCallBack: _vm.addItemCallBack,
          radioSelect: _vm.radioSelect
        },false)),_vm._v(" "),_c('div',{staticClass:"popup-btns"},_vm._l((_vm.btnConf),function(item){return _c('button',{staticClass:"btn fl",class:{'sole': _vm.btnConf.length === 1},domProps:{"textContent":_vm._s(item.text)},on:{"click":function($event){item.callBack()}}})}))],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.1@vue-loader/lib/template-compiler?{"id":"data-v-23f1414d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.1@vue-loader/lib/selector.js?type=template&index=0!./src/components/radio_popup.vue
// module id = null
// module chunks = 